import ErrorsLayout from './ErrorsLayout'

export default ErrorsLayout
